const ROW_COLLAPSIBLE_INDICATOR = 'collapsibleIndicator'
const ROW_COLLAPSIBLE_BORDER = 'row_collapsible_border'
const ROW_COLLAPSIBLE_START = 'row_collapsible_start'
const ROW_COLLAPSIBLE_END = 'row_collapsible_end'
const ROW_HEADER_UNIT_WIDTH_PX = 20;

export const setGroupingHeader = (colOutlineDepth, rowOutlineDepth, context: {hotTable:any, currentHiddenRows:number[], options:any, currentHeight: number, width: number, CELL_HEIGHT: number}) => {

  // 列ヘッダ設定
  const colGroupSettings = groupingSettingConvertor(colOutlineDepth, 'col');
  if (colGroupSettings.length > 0) {
    const maxLevel = colGroupSettings.reduce((max, setting) => setting.level > max ? setting.level : max, colGroupSettings[0].level)
    const nestedHeaders = context.options.nestedHeaders;
    const groupingHeaderOffset = nestedHeaders ? nestedHeaders.length : 0;
    const colLength = nestedHeaders
                      ? nestedHeaders.reduce((max, nestedHeader) => nestedHeader.length > max ? nestedHeader.length : max, nestedHeaders[0].length)
                      : colOutlineDepth.length
    const groupingNestedHeaders = createNestedHeaders(colGroupSettings, colLength, maxLevel); 
    if (nestedHeaders) {
      Array.prototype.push.apply(groupingNestedHeaders, nestedHeaders)
    }
    const collapsibleColumns = createCollapsibleColumns(colGroupSettings, maxLevel, groupingHeaderOffset);
    context.currentHeight += maxLevel * context.CELL_HEIGHT;
    var hiddenCols = []
    if (context.options.hiddenColumns && context.options.hiddenColumns.columns) {
      Array.prototype.push.apply(hiddenCols, context.options.hiddenColumns.columns)
    }
    colOutlineDepth.forEach((value, index) => {
      if (value && value > 0 && hiddenCols.indexOf(index) === -1) hiddenCols.push(index)
    });
    Object.assign(context.options, {
      hiddenColumns: {columns: hiddenCols},
      nestedHeaders: groupingNestedHeaders,
      collapsibleColumns: collapsibleColumns,
      columnHeaderHeight: context.CELL_HEIGHT,
      height: context.currentHeight,
      groupingHeaderCount: groupingNestedHeaders.length - groupingHeaderOffset
    })
  }
  // 行ヘッダ設定
  const rowGroupSettings = groupingSettingConvertor(rowOutlineDepth, 'row');
  if (rowGroupSettings.length > 0) {
    document.getElementById(context['htmlId']).classList.add('exist_row_grouping')
    const maxLevel = rowGroupSettings.reduce((max, setting) => setting.level > max ? setting.level : max, rowGroupSettings[0].level);
    const maxRow = rowGroupSettings.reduce((max, setting) => setting.end > max ? setting.end : max, rowGroupSettings[0].end);
    const rowHeaders = createCustomGroupingRowHeaders(context, rowGroupSettings, maxLevel, maxRow, rowOutlineDepth.length);
    const rowHeaderWidth = maxLevel * ROW_HEADER_UNIT_WIDTH_PX + 4;
    context.width += rowHeaderWidth;
    Object.assign(context.options, {
      rowHeaders: rowHeaders,
      rowHeaderWidth: rowHeaderWidth,
      width: context.width
    })
  }
}

export const initCollapseSection = (hotTable: any) => {
  const initCollapsedCols = hotTable.getSettings().initCollapsedCols;
  const initCollapsedRows = hotTable.getSettings().initCollapsedRows;
  if (!!hotTable.getSettings().collapsibleColumns && !!initCollapsedCols) {
    const collapsibleColumnsPlugin = hotTable.getPlugin('CollapsibleColumns');
    const groupingHeaderCount = !!hotTable.getSettings().groupingHeaderCount ? hotTable.getSettings().groupingHeaderCount : 0;
    const nestedHeaderDepth = !!hotTable.getSettings().nestedHeaders ? hotTable.getSettings().nestedHeaders.length : 0;
    const groupingHeaderOffset = nestedHeaderDepth - groupingHeaderCount;

    initCollapsedCols.forEach(collapsedCol => {
      collapsibleColumnsPlugin.collapseSection(
        {
          col: collapsedCol.col,
          row: collapsedCol.level - groupingHeaderOffset
        }
      )
    })
  }
  if (!!initCollapsedRows && initCollapsedRows.length > 0) {
    const hiddenRowsPlugin = hotTable.getPlugin('hiddenRows');
    hiddenRowsPlugin.enablePlugin();
    hiddenRowsPlugin.hideRows(initCollapsedRows.map(r => r.row));
    hotTable.render();
  }
}

 /**
   * colOutlineDepthでStartアイコンが含まれるセルであれば、アイコンの数を返す
   * @param colOutlineDepth
   * @param row
   * @param col
   */
  const colCulcStartIcon = (colOutlineDepth: number[], row: number, col: number) => {
    if (row != 1) {
      // アイコンは必ず1行目に表示する
      return null;
    }

    //前のカラムからcolOutlineDepthの値が増えたセルがStartセル
    const currentColValue = colOutlineDepth[col];
    if (currentColValue === 0) {
      return null;
    }
    const prevColValue = col === 0 ? 0 : colOutlineDepth[col - 1];
    //前後のカラムを比較し、数が増えていれば、Startアイコンである
    if (currentColValue > prevColValue) {
      return currentColValue - prevColValue;
    } else {
      return null;
    }
  };

  /**
   * Endアイコンが含まれるセルであればアイコンの数を返す
   * @param colOutlineDepth
   * @param row
   * @param col
   */
  const colCulcEndIcon = (colOutlineDepth: number[], row: number, col: number) => {
    if (row != 1) {
      // アイコンは必ず1行目に表示する
      return null;
    }
    //Level１：自分が０で、その前のIndexが1だったらEndです
    //Level２：自分が１で、その前のIndexが2だったらEndです
    const currentColValue = colOutlineDepth[col];

    const prevColValue = col === 0 ? 0 : colOutlineDepth[col - 1];
    if (prevColValue > currentColValue) {
      return prevColValue - currentColValue;
    } else {
      return null;
    }
  };

  const rowCulcStartIcon = (rowOutlineDepth: number[], row: number, col: number) => {
    if (col != 1) {
      // アイコンは必ず1列目に表示する
      return null;
    }

    //前のrowからrowOutlineDepthの値が増えたセルがStartセル
    const currentValue = rowOutlineDepth[row];
    if (currentValue === 0) {
      return null;
    }
    const prevValue = row === 0 ? 0 : rowOutlineDepth[row - 1];
    //前後のrowを比較し、数が増えていれば、Startアイコンである
    if (currentValue > prevValue) {
      return currentValue - prevValue;
    } else {
      return null;
    }
  };

  /**
   * Endアイコンが含まれるセルであればアイコンの数を返す
   * @param colOutlineDepth
   * @param row
   * @param col
   */
  const rowCulcEndIcon = (rowOutlineDepth: number[], row: number, col: number) => {
    if (col != 1) {
      // アイコンは必ず1列目に表示する
      return null;
    }

    const currentValue = rowOutlineDepth[row];

    const nextValue = row === rowOutlineDepth.length - 1 ? 0 : rowOutlineDepth[row + 1];
    if (nextValue < currentValue) {
      return currentValue - nextValue;
    } else {
      return null;
    }
  };

  const groupingSettingConvertor = (groupingSettings: any[], property: string) => {
    const result: any[] = [];
    const stack: any[] = [];
    groupingSettings.forEach((v, i, array) => {
      var startCount = 0;
      var endCount = 0;
      if(property==='col'){
        startCount = colCulcStartIcon(array, 1, i);
        endCount = colCulcEndIcon(array, 1, i);
      }else{
        startCount = rowCulcStartIcon(array, i, 1);
        endCount = rowCulcEndIcon(array, i, 1);
      }

      if (startCount) {
        for (var s = 0; s < startCount; s++) {
          const lastStackValue =
            stack.length > 0 ? stack[stack.length - 1].level : 0;
          stack.push({
            level: lastStackValue + 1,
            start: property === 'row' ? i - 1 : i,
            isOpen: true
          });
        }
      }
      if (endCount) {
        for (var e = 0; e < endCount; e++) {
          const groupSetting = stack.pop();
          groupSetting.end = i;
          result.push(groupSetting);
        }
      }
    });
    if (stack.length > 0) {
      throw new Error(
        "Stack is not empty. Please review the setting of grouping."
      );
    }
    result.forEach(setting => {
      const children = result.filter(x => x.level > setting.level && x.start >= setting.start && x.end <= setting.end).sort((a, b) => a.end - b.end);
      setting.children = children || []
    });
    return result;
  };

  const createNestedHeaders = (colGroupSettings:{level: number; start: number; end?: number; isOpen?: boolean;}[], colLength: number, maxLevel: number) => {
    const nestedHeaders = [];
    if (colGroupSettings.length !== 0) {
      for (let i = 0; i < maxLevel; i++) {
        const nestedHeader = [];
        const targetLevelColGroupSettings = colGroupSettings.filter(colGroupSetting => colGroupSetting.level === i + 1);
        for (let j = 0; j < colLength; j++) {
          const targetSetting = targetLevelColGroupSettings.filter(targetLevelColGroupSetting => targetLevelColGroupSetting.start === j)[0];
          if (targetSetting) {
            const colspan = targetSetting.end - targetSetting.start + 1;
            nestedHeader.push({
              label: '',
              colspan: colspan
            });
            j += colspan - 1;
          } else {
            nestedHeader.push('');
          }
        }
        nestedHeaders.push(nestedHeader);
      }
    }
    return nestedHeaders;
  }

  const createCustomGroupingRowHeaders = (
    context: {hotTable:any, currentHiddenRows:number[], options:any, currentHeight: number, width: number, CELL_HEIGHT: number},
    rowGroupSettings:{level: number; start: number; end?: number; isOpen?: boolean; children?:any[];}[], maxLevel: number, maxEndRow: number, maxRow: number
  ) => {
    const nestedRowHeaders = [];
    const initCollapsedRows = context.options.initCollapsedRows;
    for (let i = 0; i < maxRow; i++) {
      const iconWrapper = document.createElement('div');
      iconWrapper.style.height = context.CELL_HEIGHT + 'px';
      if (i <= maxEndRow) {
        const rangeRowGroupSettings = rowGroupSettings.filter(rowGroupSetting => rowGroupSetting.start <= i && rowGroupSetting.end >= i);
        const targetLevelRowGroupSettings = rowGroupSettings.filter(rowGroupSetting => rowGroupSetting.start === i);
        rangeRowGroupSettings.forEach(rangeSetting => {
          const borderEl = document.createElement('span');
          borderEl.style.left = ((100 / maxLevel) * (rangeSetting.level - 1)) + '%';
          borderEl.className = ROW_COLLAPSIBLE_BORDER;

          
          if (rangeSetting.end === i) {
            const borderBottomEl = document.createElement('span');
            borderBottomEl.style.left = borderEl.style.left;
            borderBottomEl.className = ROW_COLLAPSIBLE_BORDER;
            borderBottomEl.classList.add(ROW_COLLAPSIBLE_END);
            borderBottomEl.classList.add('level' + rangeSetting.level);
            iconWrapper.appendChild(borderBottomEl);
          }
          if (rangeSetting.start === i) {
            borderEl.classList.add(ROW_COLLAPSIBLE_START);
            // Create div(children: icon & border).
            const iconBorderEl = document.createElement('div');
            iconBorderEl.className = 'level' + rangeSetting.level;
            iconBorderEl.appendChild(borderEl);
            iconWrapper.appendChild(iconBorderEl);
          } else {
            iconWrapper.appendChild(borderEl);
          }
        });
        targetLevelRowGroupSettings.sort((a, b) => b.level - a.level).forEach(targetSetting => {
          const iconBorderEl = iconWrapper.querySelector('div.level' + targetSetting.level);
          const iconEl = document.createElement('div');
          iconEl.className = ROW_COLLAPSIBLE_INDICATOR;
          iconEl.style.left = ((100 / maxLevel) * (targetSetting.level - 1)) + '%';
          iconEl.addEventListener('click', () => {
            const hotTable = context.hotTable;
            const hiddenRowsPlugin = hotTable.getPlugin('hiddenRows');
            if (!hiddenRowsPlugin.isEnabled()) {
              hiddenRowsPlugin.enablePlugin();
            }
            toggleHiddenRows(targetSetting, iconEl, hiddenRowsPlugin, hotTable);
            hotTable.render();
          });
          if (!!initCollapsedRows && initCollapsedRows.findIndex(collapsedRow => collapsedRow.level === targetSetting.level && targetSetting.start < collapsedRow.row &&  collapsedRow.row <= targetSetting.end) !== -1) {
            const hiddenRows = context.options.hiddenRows.rows || [];
            Array.prototype.push.apply(hiddenRows, setToggleArr(targetSetting));
            context.options.hiddenRows = {rows: hiddenRows};
            targetSetting.isOpen = false;
          }
          iconBorderEl.appendChild(iconEl);
          toggleBorderAndChild(targetSetting, iconEl);
        });
      }
      nestedRowHeaders.push(iconWrapper);
    }
    return nestedRowHeaders;
  }

  const createCollapsibleColumns = (colGroupSettings:{level: number; start: number; end?: number; isOpen?: boolean;}[], maxLevel: number, groupingHeaderOffset: number) => {
    const collapsibleColumns = [];
    colGroupSettings.forEach(colGroupSetting => {
      collapsibleColumns.push({
        row: -(maxLevel - colGroupSetting.level + 1 + groupingHeaderOffset),
        col: colGroupSetting.start,
        toCol: colGroupSetting.end,
        collapsible: true
      });
    });
    return collapsibleColumns;
  }

  const setIconEl = (element, isExpanded) => {
    element.innerHTML = isExpanded ? '-' : '+';
  }

  const setToggleArr = (setting): number[] => {
    const toggleArr = [];
    for (let i = setting.start + 1; i <= setting.end; i++) {
      toggleArr.push(i);
    }
    return toggleArr;
  }

  const removeChildFromToggleArr = (setting, toggleArr:any[]): number[] => {
    if (setting.children && setting.children.length > 0) {
      return toggleArr.filter(row => setting.children.findIndex(child => !child.isOpen && child.start < row && child.end >= row) === -1)
    }
    return toggleArr;
  }

  const toggleBorderAndChild = (setting, iconEl): void => {
    setIconEl(iconEl, setting.isOpen);
    const borderEl = iconEl.parentNode.querySelector('span.' + ROW_COLLAPSIBLE_START)
    borderEl.style.visibility = setting.isOpen ? 'visible' : 'hidden';
    setting.children.forEach(child => {
      const iconBorderEl = iconEl.parentNode.parentNode.querySelector('div.level' + child.level);
      if (iconBorderEl) {
        iconBorderEl.style.display = setting.isOpen ? 'unset' : 'none';
      }
    });
  }

  const toggleHiddenRows = (setting, iconEl, hiddenRowsPlugin, hotTable) => {
    const toggleArr = setToggleArr(setting);
    if (setting.isOpen) {
      hiddenRowsPlugin.hideRows(toggleArr);
    } else {
      const toggleArrWithoutChild = removeChildFromToggleArr(setting, toggleArr);
      hiddenRowsPlugin.showRows(toggleArrWithoutChild);
    }
    // Toggle open status
    setting.isOpen = !setting.isOpen;
    // Refresh icon and border
    toggleBorderAndChild(setting, iconEl);

    if (setting.children.length > 0) {
      const lastChild = setting.children[setting.children.length - 1];
      if (lastChild.end === setting.end && !lastChild.isOpen) {
        const rowHeaderEnd = hotTable.getRowHeader(setting.end);
        const rowHeaderChildStart = hotTable.getRowHeader(lastChild.start);
        let endBdEl = rowHeaderEnd.querySelector('span.' + ROW_COLLAPSIBLE_END + '.level' + setting.level);
        if (endBdEl) {
          rowHeaderChildStart.appendChild(endBdEl);
        }
      }
    }

    const rowHeaderStart = hotTable.getRowHeader(setting.start);
    const rowHeaderEnd = hotTable.getRowHeader(setting.end);
    if (setting.isOpen) {
      for (let i = 1; i < setting.level; i++) {
        let parentEndBdEl = rowHeaderStart.querySelector('span.' + ROW_COLLAPSIBLE_END + '.level' + i);
        if (parentEndBdEl) {
          rowHeaderEnd.appendChild(parentEndBdEl);
        }
      }
    } else {
      for (let i = 1; i < setting.level; i++) {
        let parentEndBdEl = rowHeaderEnd.querySelector('span.' + ROW_COLLAPSIBLE_END + '.level' + i);
        if (parentEndBdEl) {
          rowHeaderStart.appendChild(parentEndBdEl);
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/plugins/grouping.ts